import { render, staticRenderFns } from "./CardCountry.vue?vue&type=template&id=f12e36bc&scoped=true&"
import script from "./CardCountry.vue?vue&type=script&lang=js&"
export * from "./CardCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12e36bc",
  null
  
)

export default component.exports